export default __webpack_public_path__ + "static/media/710.a3c0c1b8.svg";